<template>
    <div class="odiv">
        <div class="charg_p">
            &nbsp;
            <button type="button" class="el-button el-button--primary" @click="add">+新增患者</button>
            <div style="float: right;">
                <el-input clearable v-model="patientName" placeholder="输入名字查询" style="width: 200px"></el-input>
                <el-input clearable v-model="mobileNumber" placeholder="输入电话号码查询" style="width: 200px"></el-input>
                <el-select v-model="levelSelected" clearable>
                    <el-option
                            v-for="item in userLevelType"
                            :key="item.id"
                            :value="item.id"
                            :label="item.levelName"
                    ></el-option>
                </el-select>
                <el-button type="primary" class="el-icon-search" @click="onSubmit()"></el-button>
            </div>
        </div>
        <div>
            <el-table
                    border
                    :data="tableData"
                    style="width: 98%;margin-left: 18px"
                    :header-cell-style="tableHeaderColor"
            >
                <el-table-column type="index" label="序号" width="70"></el-table-column>
                <el-table-column prop="name" label="姓名" width="150"></el-table-column>
                <el-table-column prop="gender" label="性别" width="80"></el-table-column>
                <el-table-column prop="age" label="周岁" sortable width="100"></el-table-column>
                <el-table-column prop="mobileNumber" label="电话"></el-table-column>
                <el-table-column prop="address" label="现住址" width="auto"></el-table-column>
                <el-table-column
                        prop="diagnosisType"
                        label="状态"
                        width="150"
                        :filters="[{ text: '新诊', value: 0 }, { text: '复诊', value: 1 }]"
                        :filter-method="filterUserType"
                >
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.diagnosisType===0 ? 'danger' : 'success'"
                        >{{scope.row.diagnosisType == 0 ? '新诊' : '复诊'}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="level"
                        label="会员等级"
                        width="150"
                        :filters="[{ text: '普通会员', value: 1 }, { text: '银卡会员', value: 2 }
                                 , { text: '金卡会员', value: 3 }, { text: '白金卡会员', value: 4 }]"
                        :filter-method="filterTag"
                        filter-placement="bottom-end"
                >
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.level==1 ? 'normal' : (scope.row.level==2 ? 'warning'
                            : (scope.row.level==3 ? 'danger': 'success'))"
                        >
                            {{scope.row.level == 1 ? '普通会员' : (scope.row.level == 2 ? '银卡会员'
                            : (scope.row.level == 3 ? '金卡会员' : '白金卡会员'))}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="scoreAvail" label="会员积分" width="100"></el-table-column>
                <el-table-column prop="quota" label="可用额度" width="100"></el-table-column>
                <el-table-column prop="deposit" label="折现余额" width="100"></el-table-column>
                <el-table-column prop="overdraw" label="额度透支" width="100"></el-table-column>
                <el-table-column label="操作" width="350">
                    <template scope="scope">
                        <el-button v-if="roleId != '7'" @click="handleClick(scope.row)" type="text" size="small">修改
                        </el-button>
                        <el-button
                                v-if="roleId != '7'"
                                @click.native.prevent="deleteRow(scope.row)"
                                type="text"
                                size="small"
                                style="margin-right: 15px"
                        >删除
                        </el-button>
                        <el-popover placement="left-start" width="800" trigger="click">
                            <!-- 头部信息 -->
                            <div>
                                <p style="line-height: 50px;">历史病历</p>
                            </div>
                            <!-- 手风琴 -->
                            <el-collapse style="overflow: auto; height: 480px" v-model="activeNames" accordion>
                                <el-collapse-item
                                        v-for="(items,index) in collapseData"
                                        :title="items.inquiryDate+' '+items.diagnosisType+' '+items.patientName"
                                        :name="index"
                                        :key="index"
                                >
                  <span v-if="items.medicalRecordResponse" class="subheading">
                    <div class="accordionTitle">病历</div>
                    <p>
                      <span>主诉:</span>
                      {{items.medicalRecordResponse.mainSuit}}
                    </p>
                    <p>
                      <span>现病史:</span>
                      {{items.medicalRecordResponse.hpi}}
                    </p>
                    <p>
                      <span>既往辅助检查:</span>
                      {{items.medicalRecordResponse.assistantExamination}}
                    </p>
                    <p>
                      <span>刻下:</span>
                      {{items.medicalRecordResponse.kexia}}
                    </p>
                    <p>
                      <span>舌苔:</span>
                      {{items.medicalRecordResponse.shetai}}
                    </p>
                    <p>
                      <span>脉象:</span>
                      {{items.medicalRecordResponse.pulseCondition}}
                    </p>
                    <p>
                      <span>西医:</span>
                      {{items.medicalRecordResponse.wDiagnosisResult}}
                    </p>
                    <p>
                      <span>病症名:</span>
                      {{items.medicalRecordResponse.mDiseasesZh}}
                    </p>
                    <p>
                      <span>英文病症名:</span>
                      {{items.medicalRecordResponse.mDiseasesEn}}
                    </p>
                    <p>
                      <span>症型:</span>
                      {{items.medicalRecordResponse.mDiagnosisResult}}
                    </p>
                  </span>
                                    <span v-if="items.recipeResponse" class="subheading">
                    <div class="accordionTitle">中药汤方</div>
                    <span v-if="items.recipeResponse.recipeItemResponses">
                      <div
                              v-for="(citem,index) in items.recipeResponse.recipeItemResponses"
                              :key="index"
                              class="traditional"
                      >
                        <span>药品:</span>
                        {{citem.value}} - {{citem.number}}{{citem.unit}}
                      </div>
                    </span>
                    <p>
                      <span>副数:</span>
                      {{items.recipeResponse.quantity}}
                    </p>
                    <p>
                      <span>煎服法:</span>
                      {{items.recipeResponse.eatType}}
                    </p>
                    <p>
                      <span>忌口及日常护理:</span>
                      {{items.recipeResponse.note}}
                    </p>
                  </span>
                                    <span v-if="items.otherCheckRecordResponse" class="subheading">
                    <div class="accordionTitle">辅助检查</div>
                    <p>
                      <span>项目名称:</span>
                      {{items.otherCheckRecordResponse.checkedName}}
                    </p>
                  </span>
                                    <span v-if="items.recipeResponses" class="subheading">
                    <div class="accordionTitle">汤方信息</div>
                    <div v-for="(cell,index) in items.recipeResponses" :key="index">
                      <div>
                        <h3>{{cell.recipeName}}</h3>
                      </div>
                      <span v-for="(dall,index) in cell.recipeItemResponses" :key="index">
                        <span style="color: darkorange">
                          <span>{{dall.value}}</span>
                          <span>{{dall.number}}{{dall.unit}}</span>
                        </span>
                        <span style="padding:0 10px;">/</span>
                      </span>
                    </div>
                  </span>
                                </el-collapse-item>
                            </el-collapse>

                            <!-- 显示弹出菜单 -->
                            <el-button
                                    type="primary"
                                    icon="el-icon-tickets"
                                    slot="reference"
                                    size="mini"
                                    @click="handlecheck(scope.row)"
                            >历史病历
                            </el-button>
                        </el-popover>
                        <el-button type="primary" icon="el-icon-edit" size="mini" v-if="roleId != '7'"
                                   @click="bulu(scope.row)"></el-button>

                        <el-button type="warning" icon="el-icon-edit" size="mini"
                                   @click="editFamily(scope.row)"
                                   v-if="scope.row.level > 1 && roleId != '7'"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="病历补录" :close-on-click-modal="false" :visible.sync="centerDialogVisible" width="30%" :before-close="handleClose"
                   v-if="diagnose[index]!=undefined" center>
            <div>
                <form>
                    <div class="inOne-TabRecords">
                        <h3 class="headTitle">日期</h3>
                        <el-select v-model="query" placeholder="请选择" @change="change">
                            <el-option
                                    v-for="item in this.inquiry_Date"
                                    :key="item.value"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>

                        <!--<el-date-picker-->
                        <!--v-model="diagnose.inquiryDate"-->
                        <!--type="date"-->
                        <!--:clearable="false"-->
                        <!--placeholder="选择日期">-->

                        <!--</el-date-picker>-->
                        <h3 class="headTitle">主诉</h3>
                        <el-input
                                type="textarea"
                                v-model="diagnose[index].mainSuit"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                        <h3 class="headTitle">现病史</h3>
                        <el-input
                                type="textarea"
                                v-model="diagnose[index].hpi"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                        <h3 class="headTitle">既往辅助检查</h3>
                        <el-input
                                type="textarea"
                                v-model="diagnose[index].assistantExamination"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                        <h3 class="headTitle">刻下</h3>
                        <el-input
                                type="textarea"
                                v-model="diagnose[index].kexia"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                        <h3 class="headTitle">舌苔</h3>
                        <el-input
                                type="textarea"
                                v-model="diagnose[index].shetai"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                        <h3 class="headTitle">脉象</h3>
                        <el-input
                                type="textarea"
                                v-model="diagnose[index].pulseCondition"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                    </div>

                    <div class="zhenduan">
                        <h4>诊断</h4>
                        <h5 class="westernMedicine">西医</h5>
                        <el-input
                                type="textarea"
                                v-model="diagnose[index].wDiagnosisResult"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="1、2、3、4、5"
                        ></el-input>
                        <h5 class="westernMedicine">中医</h5>
                        <h5>病症名：</h5>
                        <el-input
                                v-model="diagnose[index].mDiseasesZh"
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                        <h5>英文病症名：</h5>
                        <el-input
                                v-model="diagnose[index].mDiseasesEn"
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                        <h5>症型：</h5>
                        <el-input
                                v-model="diagnose[index].mDiagnosisResult"
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                        ></el-input>
                    </div>
                </form>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="quxiao">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
        </el-dialog>


        <el-dialog title="维护家庭成员" :visible.sync="dialogFormVisible" width="35%">
            <template>
                <el-table
                        border
                        :data="familyData"
                        style="width: 98%;margin-left: 18px"
                        :header-cell-style="tableHeaderColor"
                >
                    <el-table-column prop="memberId" label="用户ID"></el-table-column>
                    <el-table-column prop="memberName" label="姓名"></el-table-column>
                    <!--<el-table-column-->
                    <!--prop="levelMain"-->
                    <!--label="会员等级"-->
                    <!--width="150"-->
                    <!--:filters="[{ text: '普通会员', value: 1 }, { text: '银卡会员', value: 2 }-->
                    <!--, { text: '金卡会员', value: 3 }, { text: '白金卡会员', value: 4 }]"-->
                    <!--:filter-method="filterTag"-->
                    <!--filter-placement="bottom-end"-->
                    <!--&gt;-->
                    <!--<template slot-scope="scope">-->
                    <!--<el-tag-->
                    <!--:type="scope.row.levelMain==1 ? 'normal' : (scope.row.levelMain==2 ? 'warning'-->
                    <!--: (scope.row.levelMain==3 ? 'danger': 'success'))"-->
                    <!--&gt;-->
                    <!--{{scope.row.levelMain == 1 ? '普通会员' : (scope.row.levelMain == 2 ? '银卡会员'-->
                    <!--: (scope.row.levelMain == 3 ? '金卡会员' : '白金卡会员'))}}-->
                    <!--</el-tag>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column label="操作">
                        <template scope="scope">
                            <el-button
                                    @click.native.prevent="deleteOne(scope.row)"
                                    type="text"
                                    size="small"
                                    style="margin-right: 15px"
                            >删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="dizhik"> 添&nbsp;&nbsp;&nbsp加：
                    <el-select v-model="Jname" filterable placeholder="请选择" @change="changeValue">
                        <el-option
                                v-for="item in options"
                                :key="item.index"
                                :label="item.name+ ' '+  item.mobileNumber"
                                :value="item.id + '@' + item.name">
                        </el-option>
                    </el-select>
                </div>
            </template>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelFamily">取 消</el-button>
                <el-button type="primary" @click="addFamily">确 定</el-button>
            </div>
        </el-dialog>

        <!--  //弹框部分-->
        <!--<div class="block">-->
        <!--<el-pagination-->
        <!--small-->
        <!--@size-change="handleSizeChange"-->
        <!--@current-change="handleCurrentChange"-->
        <!--:current-page.sync="currentPage"-->
        <!--:page-sizes="[2,4]"-->
        <!--:page-size="this.Size"-->
        <!--layout="sizes,total,prev, pager, next, jumper"-->
        <!--:total="this.total"-->
        <!--&gt;</el-pagination>-->
        <!--</div>-->
        <div class="block">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page=Current
                    :page-sizes="[50,100]"
                    :page-size="this.Size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="this.total"
            ></el-pagination>
        </div>
    </div>
</template>
<style type="text/css" scoped>
    .el-collapse-item__content {
        overflow: auto;
    }

    .el-button--primary {
        color: #fff;
        background-color: rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }

    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }

    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }

    /*.el-table th, .el-table tr {*/
    /*background-color: #fff;*/
    /*height: 50px;*/
    /*}*/
    .active {
        overflow-x: hidden;
        word-break: break-all;
    }

    .traditional {
        line-height: 35px;
    }

    .traditional span {
        display: inline-block;
        width: 120px;
        color: darkgreen;
    }

    .dizhik {
        margin-top: 20px;
    }

    .accordionTitle {
        font-size: 18px;
        color: #20a0ff;
    }

    .subheading p {
        line-height: 35px;
    }

    .subheading p span {
        display: inline-block;
        width: 120px;
        color: darkorange;
    }

    .block {
        margin-top: 20px;
        padding-left: 33%;
    }

    .odiv {
        width: 100%;
        padding-bottom: 50px;
        background-color: white;
    }

    .charg_p {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.68);
        line-height: 70px;
        padding: 0 20px 0 10px;
    }
</style>
<script>
    import {formatDate} from "../../common/date";

    export default {
        data() {
            return {
                // formData: [
                //     {text: "现病史:"},
                //     {text: "既往辅助检查:"},
                //     {text: "刻下:"},
                //     {text: "舌苔:"},
                //     {text: "脉象:"}
                // ],
                query: '',
                inquiry_Date: [],
                index: 0,
                patientId: 0,
                doctorId: 0,
                diagnose: {
                    // 诊断
                    inquiryDate: '',
                    assistantExamination: "",
                    hpi: "",
                    kexia: "",
                    mainSuit: "",
                    mdiagnosisResult: "",
                    mdiseasesEn: "",
                    mdiseasesZh: "",
                    pulseCondition: "",
                    shetai: "",
                    wdiagnosisResult: ""
                },
                centerDialogVisible: false,
                checkedName: "",
                activeNames: [0],       //  手风琴参数
                tableData: [],
                title: "",
                collapseData: [],
                levelSelected: "",
                userLevelType: [],
                patientName: "",
                mobileNumber: "",
                level: "",
                total: 0,
                Current: 1,
                Size: 50,
                currentPage: 0,
                userQuery: {
                    level: "",
                    mobileNumber: "",
                    patientName: ""
                },
                dialogFormVisible: false,
                options: [],
                familyData: [],
                Jname: "",
                levelMain: "",
                userId: "",
                roleId: ""
            };
        },
        mounted: function () {
            this.roleId = localStorage.roleId;
            this.getinfo();
            this.getleveltypeinfo();

        },

        methods: {
            quxiao: function () {
                this.diagnose = {
                    inquiryDate: '',
                    assistantExamination: "",
                    hpi: "",
                    kexia: "",
                    mainSuit: "",
                    mdiagnosisResult: "",
                    mdiseasesEn: "",
                    mdiseasesZh: "",
                    pulseCondition: "",
                    shetai: "",
                    wdiagnosisResult: ""
                };
                this.inquiry_Date = [];
                this.index = 0;
                this.centerDialogVisible = false;
            },
            handleClose(done) {
                this.diagnose = {
                    inquiryDate: '',
                    assistantExamination: "",
                    hpi: "",
                    kexia: "",
                    mainSuit: "",
                    mdiagnosisResult: "",
                    mdiseasesEn: "",
                    mdiseasesZh: "",
                    pulseCondition: "",
                    shetai: "",
                    wdiagnosisResult: ""
                };
                this.inquiry_Date = [];
                this.index = 0;
                done();
            },

            bulu: function (e) {
                this.centerDialogVisible = true;
                console.log(this.inquiry_Date);
                console.log(this.diagnose[0]);
                this.patientId = e.id;
                this.doctorId = localStorage.uid;

                this.open();
            },


            editFamily: function (e) {
                this.dialogFormVisible = true;
                this.levelMain = e.level
                this.userId = e.id
                // 获取患者信息
                let rolename = {rolename: '患者'}
                this.$axios({
                    url: '/api/user/usersByRolename',
                    method: 'GET',
                    params: rolename
                }).then(res => {
                    this.options = res.data.data;
                }).catch(err => {
                    this.$message.error('数据获取失败');
                });


                var param = {"userId": e.id}
                this.$axios({
                    url: '/api/user/family/findAll',
                    method: 'GET',
                    params: param
                }).then(res => {
                    this.familyData = res.data.data;
                }).catch(err => {
                    this.$message.error('数据获取失败');
                });
            },


            changeValue(value) {
                var userId = value.split('@')[0]

                var userName = value.split('@')[1];
                var user = {"userId": this.userId, "memberId": userId, "memberName": userName}
                this.familyData.push(user)
//            alert(this.payerId + 'dsad' + this.payerQuota)
            },


            //删除某个家庭成员
            deleteOne(row) {
                console.log(this.familyData.length)
                let id = row.memberId;
                for (var i = 0; i < this.familyData.length; i++) {
                    console.log(this.familyData[i])
                    if (this.familyData[i].memberId == id) {
                        this.familyData.splice(i, 1)
                    }
                }
            },

            //删除某个家庭成员
            cancelFamily() {
                this.familyData = []
                this.dialogFormVisible = false
            },

            //添加家庭成员
            addFamily() {
                var param = this.familyData
                this.$axios({
                    url: '/api/user/family/addFamily',
                    method: 'POST',
                    data: param
                }).then(res => {
                    this.$message.success('添加成功');
                    this.dialogFormVisible = false
                }).catch(err => {
                    this.$message.error('数据获取失败');
                });
            },
            open: function () {
                this.$axios({
                    url: '/api/inquiry/history/medicalRecord/' + this.patientId,
                    method: 'GET'
                }).then(res => {
                    console.log(res.data)
                    let Data = res.data.data;
                    if (Data) {
                        for (let i = 0; i < Data.length; i++) {
                            this.inquiry_Date.push(Data[i].inquiryDate)
                            // if (Data[i]!=null) {
                            //
                            // }
                        }
                    }
                    this.query = this.inquiry_Date[0];
                    this.diagnose = Data;
                    if (this.diagnose[0] == undefined) {
                        this.$message({
                            type: "warning",
                            message: '暂无记录'
                        })
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            change: function () {
                let inquiry_Date = this.diagnose;
                for (let k = 0; k < inquiry_Date.length; k++) {
                    if (this.query == inquiry_Date[k].inquiryDate) {
                        this.index = k;
                    }
                }

            },
            sure: function () {

                // this.diagnose.inquiryDate = formatDate(
                //   this.diagnose.inquiryDate,
                //   "yyyy-MM-dd"
                // );
                this.diagnose[this.index].doctorId = this.doctorId;
                this.diagnose[this.index].patientId = this.patientId;
                console.log(this.diagnose[this.index]);
                this.$axios({
                    url: "/api/inquiry/makeup/history/" + this.diagnose[this.index].medicalRecordId,
                    method: "POST",
                    data: this.diagnose[this.index]
                })
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: "success",
                                message: "保存成功"
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: res.data.msg
                            });
                        }
                    })
                    .catch(err => {
                        console.log(err.data);
                    });
                this.centerDialogVisible = false;
            },
            onSubmit: function () {
                (this.userQuery.level = this.levelSelected),
                    (this.userQuery.mobileNumber = this.mobileNumber),
                    (this.userQuery.patientName = this.patientName),
                    this.Current = 1;
                this.getinfo();
            },
            handlecheck: function (val) {
                console.log(val);
                this.$axios({
                    url: "/api/inquiry/history/" + val.id,
                    method: "GET"
                })
                    .then(res => {
                        let resdata = res.data.data;
                        this.collapseData = res.data.data;
                    })
                    .catch(err => {
                        console.log(err.data);
                    });
            },
            getinfo: function () {
                this.$axios({
                    method: "POST",
                    url:
                        "/api/user/patients/pageNumber/" +
                        this.Current +
                        "/size/" +
                        this.Size,
                    data: this.userQuery
                })
                    .then(res => {
                        this.tableData = res.data.data.content;
                        this.total = res.data.data.totalElements;
                    })
                    .catch(err => {
                        // console.log(err)
                    });
            },
            getleveltypeinfo: function () {
                this.$axios({
                    url: "/api/userlevel/all",
                    method: "GET"
                })
                    .then(res => {
                        // console.log(res.data)
                        this.userLevelType = res.data.data;
                    })
                    .catch(err => {
                        // console.log(err.data);
                    });
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.Size = val;
                this.getinfo();
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.Current = val;
                this.getinfo();
            },
            filterTag(value, row) {
                return row.level == value;
            },
            filterUserType(value, row) {
                return row.diagnosisType == value;
            },

            //修改
            handleClick: function (row) {
                // console.log(row)
                let id = row.id;
                this.$router.push({path: "./addone", query: {id}});
            },
            //删除
            deleteRow(row) {
                // console.log(row)
                let id = row.id;
                this.$confirm("是否确定删除?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$axios({
                            url: "/api/user/" + id,
                            method: "DELETE"
                        }).then(res => {
                            if (res.data.code == 200) {
                                this.getinfo();
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            add: function () {
                this.$router.push({path: "./addone"});
            },
            tableHeaderColor({row, column, rowIndex, columnIndex}) {
                if (rowIndex === 0) {
                    return "background-color:#f2f2f2;color: #a4a7af;";
                }
            }
        },


    }
</script>



// WEBPACK FOOTER //
// patientlist.vue?c7f36d7e